import { sylvanus } from '~/services/serviceInstances';

type DeleteDdeTableDocumentRequest = {
  documentHandlerId: string;
  tableId: string;
};

export const deleteDdeTableDocument = async ({
  documentHandlerId,
  tableId,
}: DeleteDdeTableDocumentRequest): Promise<void> => {
  await sylvanus.remove(`/dde/table/${tableId}/${documentHandlerId}`);
};
